export { default } from "./SlcCounter"
